import { render, staticRenderFns } from "./AccessResource.vue?vue&type=template&id=3b4ac008&"
import script from "./AccessResource.vue?vue&type=script&lang=ts&"
export * from "./AccessResource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports